//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DefaultDisclaimerTable",
  props: {
    defaultDisclaimer: {
      type: Object,
      default: () => ({})
    },
    defaultDisclaimerEnabled: {
      type: Boolean,
      required: true
    },
    isBrokerage: {
      type: Boolean
    }
  },
  data() {
    return {
      columns: ["enabled", "message", "document"]
    };
  },
  computed: {
    options() {
      return {
        filterable: false,
        showChildRowToggler: false,
        headings: {
          enabled: `${this.$t("global.words.enabled")}?`,
          message: this.$t("settings.disclaimers.consentMessageTitle"),
          document: this.$t("settings.disclaimers.linkedDocument")
        },
        sortable: [],
        tabbable: false,
        columnsClasses: {
          enabled: "text-center",
          message: "w-75"
        },
        skin: "table table-hover",
        perPage: 99999
      };
    }
  },
  methods: {
    showPreviewer({
      fileName,
      documentId
    }) {
      this.$emit("show-document-previewer", {
        fileName,
        documentId
      });
    },
    updateDefaultDisclaimerEnabled(defaultDisclaimerEnabled) {
      this.$emit("update-default-disclaimer-enabled", defaultDisclaimerEnabled);
    }
  }
});